/*
 * ProjectList.tsx
 * Author: fwunderlich
 * Date: 18.01.2023
 *
 * Copyright: DMT GmbH & Co. KG
 */

import React, {useEffect, useState} from 'react';
import CustomDataTable, {ColumnObject} from '../global/CustomDataTable';
import {useGetProjectListQuery} from '../../redux/rtk/injectedPersonApi';
import {Parcel, Person} from '../functions/GlobalData';
import {useTranslation} from 'react-i18next';

import {
    getColumnsParcel,
    getColumnsProjectList,
    getFiltersLandRegister,
    getFiltersParcel, getFiltersProjectList
} from "../functions/GlobalData";
import {classNames} from "primereact/utils";

type Props = {
    projectId: any,
    mapping: any,
    hideGlobalFilter: boolean,
    showColumnFilters: boolean,
    className?: string,
    runRefetch?: boolean,
    scrollHeight?: string,
    skeletonCount?: number,
}


export const ProjectList = (props: Props) => {
    const {t} = useTranslation(['common', 'globalData']);

    const [values, setValues] = useState<any>([]);

    const [dataLoaded, setDataLoaded] = useState(false);
    const [selection, setSelection] = useState<Person[]>([]);
    const [skip, setSkip] = useState(false);
    const [columns, setColumns] = useState<ColumnObject[]>([]);
    const [returnedData, setReturnedData] = useState<Parcel>();

    const {
        data: projectList = undefined, isLoading,
        isSuccess,
        isFetching,
        isError,
        error,
        refetch,
    } = useGetProjectListQuery({
        projectId: props.projectId,
        mapping: props.mapping
    }, {skip});

    if (isError) {
        console.log({error});
    }

    useEffect(() => {
        setColumns(getColumnsProjectList(t));
        if (projectList) {
            const expandedRowsTemp: any[] = [];
            const newArray = JSON.parse(JSON.stringify(projectList));
            setValues(newArray);
            setDataLoaded(true);
            // setSkip(true);
        }
    }, [projectList]);

    useEffect(() => {
        if (props.runRefetch) {
            console.log('refetch data');
            setSkip(false);
        }
    }, [props.runRefetch]);

    return (
        <div className={classNames('h-full', props.className)}>
            <CustomDataTable
                id='projectListDataTable'
                headerTitle={t('globalData:columns.projects')}
                className={props.className}
                columns={columns}
                scrollHeight={props.scrollHeight}
                sortable={true}
                value={values}
                filters={getFiltersProjectList()}
                paginator={true}
                paginatorHideAll={true}
                displayColumnFilter={props.showColumnFilters}
                editable={false}
                dataloaded={dataLoaded}
                hideGlobalFilter={props.hideGlobalFilter}
                skeletonCount={props.skeletonCount}
            />
        </div>
    );
};
